import { InvoiceDocumentType } from '../enums/invoiceDocumentType'

export const isDocumentTypeRecurringInvoice = (documentType: InvoiceDocumentType): boolean =>
  documentType === InvoiceDocumentType.RecurringInvoice
